/** PURE_IMPORTS_START .._operators_last PURE_IMPORTS_END */
import { last as higherOrder } from '../operators/last';
/* tslint:enable:max-line-length */
/**
 * Returns an Observable that emits only the last item emitted by the source Observable.
 * It optionally takes a predicate function as a parameter, in which case, rather than emitting
 * the last item from the source Observable, the resulting Observable will emit the last item
 * from the source Observable that satisfies the predicate.
 *
 * <img src="./img/last.png" width="100%">
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 * @param {function} predicate - The condition any source emitted item has to satisfy.
 * @return {Observable} An Observable that emits only the last item satisfying the given condition
 * from the source, or an NoSuchElementException if no such items are emitted.
 * @throws - Throws if no items that match the predicate are emitted by the source Observable.
 * @method last
 * @owner Observable
 */
export function last(predicate, resultSelector, defaultValue) {
    return higherOrder(predicate, resultSelector, defaultValue)(this);
}
//# sourceMappingURL=last.js.map 



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/operator/last.js
// module id = 822
// module chunks = 0